import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', () => {    
    const init = () => {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        setTimeout(() => {
            window.carousels();
            //window.anims();
            window.afterLoadAnims();
            document.getElementById('cover').remove();

            // FIX: carousels() (Swiper w sekcji odbiorcy-kursu.ejs, PRZED
            // #program) może zmienić wysokość tej sekcji już PO jedynym
            // automatycznym refreshu GSAP (który odpala się na "load",
            // czyli 250ms wcześniej niż ten blok). Taka zmiana przesuwa
            // realną pozycję #program w dokumencie, ale ScrollTrigger o
            // tym nie wie, dopóki nie każemy mu przeliczyć pozycji.
            requestAnimationFrame(() => ScrollTrigger.refresh());
        }, 250);  
    };
    
    window.addEventListener('load', init);

}, false);